export default __webpack_public_path__ + "static/media/game_2_r.2f4e843a.png";